// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"d5fe5935","247":"dcfcfbd9","284":"6343a53b","422":"1c5a3842","627":"6fe0567c","867":"1411fc9c","923":"a878107e","938":"62e8b0e7"}[chunkId] + ".chunk.js";
};